import { AccountTransactionList } from "../tlSalesOnAccount";

const TLPurchaseOnAccount = () => <AccountTransactionList
  title="Purchase On Account"
  moduleId="ACTPOA"
  storageKey="purchaseOnAccount.filters"
  accessPath="/api/purchase-on-account/access"
  statusPath="/api/purchase-on-account/status"
  transactionPath="/App/PurchaseOnAccountTransaction"
  printPath="/api/purchase-on-account/print"
  print2307Path="/api/purchase-on-account/print-2307"
  documentPrefix="POA"
  rowClassPrefix="poa"
  centeredErrors
  hideUnauthorizedActions
/>;

export default TLPurchaseOnAccount;
